





































































import { Getter, Action, namespace } from 'vuex-class';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { AcgnPop } from '@acgn/herm/src/ui';
import { Progress, Alert } from 'element-ui';
import { complexClone } from '@acgn/herm/src/util/serialize';

const authAction = namespace('desk/auth').Action;
const authGetter = namespace('desk/auth').Getter;

interface ResetPwdType { // 修改密码类型
  old_password?: string; // 老密码
  password?: string; // 新密码
  rePassword?: string; // 重复新密码
}

@Component({
  components: {
    [Progress.name]: Progress,
    [Alert.name]: Alert,
    AcgnPop
  }
})
export default class ResetPwd extends Vue {

  @Prop({ type: Boolean, default: false }) private visible: boolean; // 控制dialog显示

  @authAction private resetPwd: any; // 修改密码

  @authGetter private loadings: any; // 登录loading
  @authGetter private userInfo: any; // 用户信息

  private inputType: string = 'text';

  private formData: ResetPwdType = {
    old_password: '',
    password: '',
    rePassword: ''
  };

  private pwdLevel: any = { percentage: 0, status: 'exception' }; // 密码等级
  private isSimplePwd: boolean = false;  // 是否是简单密码
  private showClose: boolean = true;  // 是否显示关闭按钮
  private warningText: string = '当前密码安全性过低，请设置强度更高的密码';
  private pwdColor: any = { // 密码强度进度显示
    0: { percentage: 0, status: 'exception' },
    1: { percentage: 33, status: 'exception' },
    2: { percentage: 66, status: 'warning' },
    3: { percentage: 100, status: 'success' }
  };

  private get show() {
    return this.visible;
  }
  private set show(v) {
    this.$emit('update:visible', v);
  }

  // 获取表单验证规则
  private get rules() {
    const rules = {
      old_password: [
        { required: true, message: '请输入原密码', trigger: 'blur' }
      ],
      password: [
        { required: true, message: '请输入新密码', trigger: 'blur' },
        { validator: this.validatePass, trigger: 'blur' },
        { validator: this.validatePassSimple, trigger: 'blur' }
      ],
      rePassword: [
        { required: true, message: '请再次输入新密码', trigger: 'blur' },
        { validator: this.reValidatePass, trigger: 'blur' }
      ]
    };
    return rules;
  }

  @Watch('userInfo.needResetPass')
  private needResetPass() {
    this.validPwd();
  }

  @Watch('formData.password')
  private pwdChange(val: any) {
    this.isSimplePwd = false;
    let lv = 0;
    const regNum = /([0-9])+/;
    const regA = /([A-Z])+/;
    const regAa = /([^A-Z0-9])+/;
    if (val.match(regNum)) {
      lv++;
    }
    if (val.match(regA)) {
      lv++;
    }
    if (val.match(regAa)) {
      lv++;
    }
    const valLen = val.length;
    if (valLen < 6 || lv === 1) {
      this.isSimplePwd = true;
      lv = valLen === 0 ? 0 : 1;
    }
    this.pwdLevel = this.pwdColor[lv];
  }

  private created() {
    this.validPwd();
  }

  // 取消
  private close() {
    this.show = false;
    (this.$refs.form as any).resetFields();
  }

  private changeInputType() {
    this.inputType = 'password';
  }

  private validPwd() {
    if (!this.userInfo.needResetPass) {
      return;
    }
    this.show = true;
    this.showClose = false;
  }

  private validatePass(rule: any, value: any, callback: any) {
    if (value === this.formData.old_password) {
      callback(new Error('新密码与原密码一致，请重新设置'));
    } else {
      callback();
    }
  }
  private validatePassSimple(rule: any, value: any, callback: any) {
    if (this.isSimplePwd) {
      callback(new Error(this.warningText));
    } else {
      callback();
    }
  }
  private reValidatePass(rule: any, value: any, callback: any) {
    if (value !== this.formData.password) {
      callback(new Error('新密码前后两次输入不一致，请重新设置'));
    } else {
      callback();
    }
  }

  // 修改密码
  private submit() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (!valid) {
        return;
      }
      try {
        const postData: any = complexClone(this.formData);
        delete postData.rePassword;
        await this.resetPwd(postData);
        this.$message.success('密码修改成功');
        this.close();
        setTimeout(() => {
          this.showClose = true;
        });
      } catch (ex) {
        this.$message.error(ex.message);
      }
    });
  }
}
